export const quote = (str) => I18n.locale === 'de' ? `„${str}“` : `“${str}“`

export const truncate = (text, { length }) => {
  return (text.length > length) ? `${text.substring(0, length)}…` : text
}

export const toSentence = (...words) => {
  const and = I18n.locale === 'de' ? 'und' : 'and'

  switch (words.length) {
    case 0: return ``
    case 1: return `${words[0]}`
    case 2: return `${words[0]} ${and} ${words[1]}`
    default: return `${words.slice(0, -1).join(', ')} ${and} ${[...words].pop()}`
  }
}

export const formatNumber = (number, { precision } = {}) => {
  const options = {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  }
  return Intl.NumberFormat(I18n.locale, options).format(number)
}

// exactly matches rails' String#underscore (except for custom acronyms)
export const underscore = (string) => {
  if (!/[A-Z-]|::/.test(string)) return string

  return string
    .replace(/::/g, '/')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g, (_m, g1, g2) => `${g1}_${g2}`)
    .replace(/([a-z\d])([A-Z])/g, (_m, g1, g2) => `${g1}_${g2}`)
    .replace(/-/g, '_')
    .toLowerCase()
}
